import axios from 'axios';
import { Message } from 'element-ui';
import { i18n } from '@/i18n/index'
axios.interceptors.request.use(config => {
  return config
}, error => {
  Message.error(i18n.t('el.systemAbnormality'));
  return Promise.reject(error)
});

axios.interceptors.response.use(response => {
  return response
}, error => {
  if (error.response.data.message) {
    Message.error(error.response.data.message);
  }
  return Promise.resolve(error.response)
});

// 生产环境
let baseURL = 'https://dtc-ethscan.datatradechain.net' //生产环境
// let baseURL = 'http://13.212.58.194:9001' //测试环境
// let baseURL = 'http://192.168.1.103:9001' //本地环境
export function ajax(url, data, type,host) {

  axios.defaults.baseURL = `${baseURL}${process.env.VUE_APP_URL}`;
  return new Promise((resolve, reject) => {
    let option = {
      method: type,
      url,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json; charset=UTF-8'
      }
    }
    let exp = /^(post|POST)/ig
    if (exp.test(type)) {
      option['data'] = data
    } 
    // let exp = /^(get|GET)/ig
    // if (exp.test(type)) {
    //   option['params'] = data
    // } else {
    //   option['data'] = data
    // }
    axios(option).then(
      (response) => {
        if (response && (response.status === 200)) {
          resolve(response.data)
        }else{
          Message.error(i18n.t('el.systemAbnormality'));
        }
      }
    ).catch(
      (err) => {
        
      }
    )
  })

}
